<template>
  <MyModal
    title="风机部署"
    width="400px"
    height="auto"
    @closeClick="handleCloseModalClick"
  >
    <div class="my-content">
      <div class="core">
        <div class="tab">
          <div
            :class="[
              'tab-item',
              {
                'is-active': item.active
              }
            ]"
            v-for="(item, index) in tabList"
            :key="index"
            @click="handleTabClick(item, index)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>

      <div class="adjust-desc-new">
        鼠标选中可以进行风机调整
      </div>

      <div class="deploy-content" v-if="activeName === '自动布机'">
        <div class="row">
          <div
            :class="[
              'row-item',
              {
                place: item.place == 1
              }
            ]"
            v-for="(item, index) in rowItemList"
            :key="index"
          >
            <div class="row-item-core">
              <div class="key">{{ item.label }}</div>
              <div class="value">
                <StandInput
                  v-model="item.value"
                  :myType="item.type"
                  :onlyNumber="item.onlyNumber"
                  :unit="item.unit"
                  :interger="item.interger"
                  :selectOptions="item.selectOptions"
                ></StandInput>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="deploy-content" v-if="activeName === '手动布机'">
        <div class="manual-row">
          <div class="key">风机类型</div>
          <div class="value">
            <StandInput
              v-model="manualTurbineParam.turbineType"
              myType="select"
              :selectOptions="manualTypeList"
              :disabled="toolUIStatus.fengji"
            ></StandInput>
          </div>
          <div class="el-btn-wrapper">
            <el-button type="text" @click="applyTur">应用全场</el-button>
          </div>
        </div>
        <div class="manual-row">
          <div class="key">轮毂高度</div>
          <div class="value">
            <StandInput
              v-model="manualTurbineParam.turbineHeight"
              :onlyNumber="true"
              unit="米"
              :disabled="toolUIStatus.fengji"
            ></StandInput>
          </div>
          <div class="el-btn-wrapper">
            <el-button type="text" @click="applyHeight">应用全场</el-button>
          </div>
        </div>
      </div>

      <!-- <div class="adjust-area" v-if="activeName === '手动布机'">
        <template v-if="!specificDragFlag">
          <ct-button :btnClick="handleAdjustClick">调整</ct-button>
        </template>
        <template v-else>
          <span class="adjust-desc">请点击风机进行调整！</span>
          <ct-button type="primary" :btnClick="handleSaveRoadClick"
            >保存</ct-button
          >
          <ct-button :btnClick="handleCancelRoadResult">取消</ct-button>
        </template>
      </div> -->

      <div class="deploy-btn-wrapper" v-if="activeName === '自动布机'">
        <ct-button type="primary" :btnClick="handleDeployClick"
          >开始部署</ct-button
        >
      </div>

      <div class="add-fengji-wrapper">
        <div v-if="activeName === '手动布机'" class="add-fengji">
          <ct-button
            :btnClick="
              () => {
                showImportWindFarmDialog = true;
              }
            "
            >风机导入</ct-button
          >
          <ct-button
            type="primary"
            v-if="!toolUIStatus.fengji"
            :btnClick="
              () => {
                handleAddFengji(true);
              }
            "
          >
            添加风机
          </ct-button>
          <div v-else class="add-fengji">
            <ct-button :btnClick="handleSaceFengjiClick" type="primary"
              >保存</ct-button
            >
            <ct-button
              :btnClick="
                () => {
                  cancelCreateFengji(false);
                }
              "
              >取消</ct-button
            >
          </div>
        </div>
      </div>

      <div class="limit-area">
        <div class="my-title">
          限制区域
          <i
            :class="[
              'el-icon-circle-plus-outline',
              {
                'is-active': toolUIStatus.limitAdd
              }
            ]"
            @click="
              () => {
                handleLimitClick();
              }
            "
          ></i>
        </div>
        <div class="area-content">
          <div
            class="depoly-content-item"
            v-for="(item, index) in exclusiveList"
            :key="index"
          >
            <el-tag> 限制区域{{ Number(index) + 1 }}</el-tag>
            <div class="btns">
              <i
                :class="[
                  'el-icon-view',
                  {
                    'is-active': item.isShow
                  }
                ]"
                @click="handleViewClick(item, index)"
              ></i>
              <i
                class="el-icon-delete"
                @click="handleDelLimitClick(item, index)"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div class="shengyazhan-area">
        <div class="my-title">
          升压站
          <i
            :class="[
              'el-icon-circle-plus-outline',
              {
                'is-active': toolUIStatus.shengyazhanAdd
              }
            ]"
            @click="
              () => {
                handleShengyaAddClick();
              }
            "
          ></i>
        </div>
        <div class="area-content">
          <template>
            <div
              class="depoly-content-item"
              v-for="(item, index) in boosterList"
              :key="index"
            >
              <template v-if="!isBootEdit">
                <el-tag> 升压站</el-tag>
                <el-divider direction="vertical"></el-divider>
                <el-tag>纬度: {{ toFixed(item.lat, 6) }}</el-tag>
                <el-divider direction="vertical"></el-divider>
                <el-tag> 经度: {{ toFixed(item.lon, 6) }}</el-tag>
                <div class="btns">
                  <i class="el-icon-edit" @click="handleEditBoClick(item)"></i>
                  <i
                    :class="[
                      'el-icon-view',
                      {
                        'is-active': item.isShow
                      }
                    ]"
                    @click="handleViewSyzClick(item, index)"
                  ></i>
                  <i
                    class="el-icon-delete"
                    @click="handleDelBoostClick(item, index)"
                  ></i>
                </div>
              </template>
              <template v-else>
                <el-tag> 升压站</el-tag>
                <el-divider direction="vertical"></el-divider>
                <el-tag>
                  <span class="mr-10">纬度:</span>
                  <input
                    class="clean-input width-40"
                    v-model="item.lat"
                    type="text"
                /></el-tag>
                <el-divider direction="vertical"></el-divider>
                <el-tag>
                  <span class="mr-10">经度:</span>
                  <input
                    class="clean-input width-40"
                    v-model="item.lon"
                    type="text"
                /></el-tag>
                <div class="btns">
                  <i
                    :class="['el-icon-check']"
                    @click="() => handleSaveBoClick(item)"
                  ></i>
                  <i
                    class="el-icon-close"
                    @click="() => handleCancelBoClick(item)"
                  ></i>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>

    <modal
      title="导入风机"
      width="500px"
      :visible.sync="showImportWindFarmDialog"
      @close="importDialogClose"
    >
      <div class="inner-wrapper">
        <el-form
          ref="form"
          :rules="uploadrules"
          :model="uploadForm"
          label-width="120px"
        >
          <el-form-item label="风机文件" prop="uploadFileName">
            <el-upload
              class="upload-demo"
              ref="upload"
              :with-credentials="true"
              :auto-upload="false"
              :action="action"
              :data="extraData"
              :on-change="handleUploadChange"
              :on-success="uploadSuccessCb"
              :on-error="uploadErrorCb"
              :file-list="fileList"
              :show-file-list="false"
            >
              <div class="click-area">
                <div class="file-name">{{ uploadForm.uploadFileName }}</div>
                <el-button type="text">上传</el-button>
              </div>
            </el-upload>
          </el-form-item>
        </el-form>

        <div class="my-btn-warpper">
          <ct-button :btnClick="handleTriImport" type="primary"
            >风机导入</ct-button
          >
          <div class="bar"></div>
          <ct-button :btnClick="downloadTemplate">模板下载</ct-button>
        </div>
      </div>
    </modal>
  </MyModal>
</template>

<script>
import MyModal from '../modal';
import StandInput from '../stand-input';
import {
  toFixed,
  parseMapDataToGeoInfo,
  booleanPointInPolygon
} from '../utils';
import loadingMask from '@/components/loading-mask';
import { getToken } from '@/utils';
import { mapGetters } from 'vuex';
import L from 'leaflet';
export default {
  components: {
    MyModal,
    StandInput
  },
  computed: {
    ...mapGetters('WindFarm', [
      'toolUIStatus',
      'exclusiveList',
      'boosterList',
      'specificDragFlag'
    ]),
    activeName() {
      return this.tabList.find(i => i.active).name;
    },
    extraData() {
      return {
        windfarmId: this.$route.query.windfarmId,
        apiKey: getToken()
      };
    }
  },
  data() {
    return {
      isBootEdit: false,
      fileList: [],
      file: null,
      action: `${process.env.VUE_APP_API_HOST}/windfarm/windfarm/uploadTurbineFile`,
      uploadForm: {
        uploadFileName: ''
      },
      uploadrules: {
        uploadFileName: [
          { required: true, message: '请上传风机文件', trigger: 'change' }
        ]
      },
      showImportWindFarmDialog: false,
      manualFengjiList: [],
      tabList: [
        {
          name: '自动布机',
          active: true
        },
        {
          name: '手动布机',
          active: false
        }
      ],
      rowItemList: [
        {
          label: '风机类型',
          key: 'turbineType',
          value: null,
          unit: '',
          onlyNumber: false,
          type: 'select',
          selectOptions: [],
          place: 1
        },
        {
          label: '轮毂高度',
          key: 'turbineHubHeight',
          value: null,
          onlyNumber: true,
          interger: true,
          type: 'input',
          unit: '米'
        },
        {
          label: '风机数量',
          key: 'turbineCount',
          value: null,
          interger: true,
          unit: '台',
          onlyNumber: true,
          type: 'input'
        },
        {
          label: '最小风速',
          key: 'minWindSpeed',
          value: null,
          unit: 'm/s',
          onlyNumber: true,
          type: 'input'
        },
        {
          label: '最大坡度',
          key: 'maxSlopeTurbine',
          value: null,
          unit: '度',
          onlyNumber: true,
          type: 'input'
        },

        {
          label: '长轴',
          key: 'longAxisDistance',
          value: null,
          unit: 'D',
          onlyNumber: true,
          type: 'input'
        },
        {
          label: '短轴',
          key: 'shortAxisDistance',
          value: null,
          unit: 'D',
          onlyNumber: true,
          type: 'input'
        },
        {
          label: '长轴方位',
          key: 'longAxisAngle',
          value: null,
          unit: '度',
          onlyNumber: true,
          type: 'input'
        },
        {
          label: '边界距离',
          key: 'boundaryDistance',
          value: null,
          unit: '米',
          onlyNumber: true,
          type: 'input'
        }
      ],
      limitList: [],
      turbineTypeList: [],
      autoTurbineParam: {
        maxSlope: null,
        turbineCount: null,
        maxAltitude: null,
        turbineType: null,
        turbineTypeId: null,
        turbineHeight: null,
        turbineDistance: null
      },
      manualTypeList: [],
      manualTurbineParam: {
        turbineTypeId: null,
        turbineHeight: null
      },
      store: null
    };
  },
  created() {
    this.$bus.$on('createShengyazhan', this.addBooster);
    this.$bus.$on('createLimitAdd', this.addExclusive);
    this.$bus.$on('createfengji', this.createfengji);
    this.$store.commit('WindFarm/SET_FENGJIBIANHAOFLAG', true);
  },
  beforeDestroy() {
    this.$bus.$off('createShengyazhan', this.addBooster);
    this.$bus.$off('createLimitAdd', this.addExclusive);
    this.$bus.$off('createfengji', this.createfengji);
    this.cancelCreateFengji(false);
    this.$store.commit('WindFarm/SET_specificDragFlag', false);
    this.$store.commit('WindFarm/SET_FENGJIBIANHAOFLAG', false);
    // this.handleCancelFjResult();
  },
  mounted() {
    this.$store.commit('WindFarm/UPDATE_TUILIST');
    this.queryLimitList();
    this.queryAutoParams();
    this.queryManualParams();

    this.handleAdjustClick();
  },
  methods: {
    handleEditBoClick(data) {
      this.isBootEdit = true;

      //console.log(data);
      this.store = {
        lat: data.lat,
        lon: data.lon
      };
    },
    handleCancelBoClick(data) {
      data.lat = this.store.lat;
      data.lon = this.store.lon;
      this.isBootEdit = false;
    },
    handleSaveBoClick(data) {
      this.$bus.$emit('getWindScopeData', map => {
        const poly = map.map(item => [item.lat, item.lng]);
        const result = booleanPointInPolygon([data.lat, data.lon], [poly]);

        if (!result) {
          return this.$message.warning('升压站必须在风场内部');
        }

        this.$postForm('/windfarm/windfarm/saveBooster', {
          showError: true,
          showSuccess: true,
          data: {
            lat: data.lat,
            lon: data.lon,
            windfarmId: this.$route.query.windfarmId
          }
        }).then(() => {
          this.handleShengyaAddClick(false);
          this.queryBoosterList();
          this.isBootEdit = false;
        });
      });
    },
    handleTriImport() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const formData = new FormData();
          formData.append('file', this.file?.raw);
          formData.append('apiKey', getToken());
          formData.append('windfarmId', this.$route.query.windfarmId);

          this.$fetch({
            method: 'POST',
            url: 'windfarm/windfarm/uploadTurbineFile',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            noJudge: true
          }).then(res => {
            const { code } = res.data;

            if (code == 0) {
              this.aswitch = loadingMask({ mask: true });
              this.$refs.upload.submit();
            }
          });
        }
      });
    },
    downloadTemplate() {
      window.open(
        `${process.env.VUE_APP_API_HOST}/windfarm/project/getTemplateFile?fileName=turbineInfoFile.xlsx`,
        '_parent'
      );
    },
    uploadErrorCb() {
      this.file = null;
      this.showImportWindFarmDialog = false;
      this.$refs.form.resetFields();

      this.aswitch && this.aswitch.close();
    },
    uploadSuccessCb(res) {
      const { code, message } = res;
      this.aswitch && this.aswitch.close();
      this.fileList = [];
      this.uploadForm.uploadFileName = '';

      this.$refs.form.resetFields();
      this.file = '';

      this.$refs.upload.clearFiles();
      if (code === 0) {
        this.showImportWindFarmDialog = false;
        this.$message({
          message: message,
          type: 'success'
        });
        this.uploadForm.uploadFileName = '';

        this.$store.dispatch('WindFarm/getWindfarmTurbineList', {
          params: {
            windfarmId: this.$route.query.windfarmId
          }
        });

        // 更新道路
        this.$store.dispatch('WindFarm/getRoadList', {
          params: {
            windfarmId: this.$route.query.windfarmId
          }
        });

        // 成功后做的事情
        // this.$bus.$emit('updateWindFarmAndItems', {
        //   type: 'windFarm',
        //   data: windfarm
        // });
      } else {
        this.$message({
          message: message,
          type: 'error'
        });
      }
    },
    handleUploadChange(file, fileList) {
      if (!fileList.length) {
        this.file = null;
        this.uploadForm.uploadFileName = '';
      } else {
        this.file = file;
        this.uploadForm.uploadFileName = file?.name;
        this.fileList = [file];
      }

      // this.fileList = fileList;
      // this.file = null;
      // this.uploadForm.uploadFileName = '';
    },
    importDialogClose() {
      this.uploadForm.uploadFileName = '';
    },
    handleAdjustClick() {
      if (this.toolUIStatus['fengji']) {
        return this.$message.warning('正在添加风机，不可进行调整');
      }

      this.$nextTick(() => {
        this.$bus.$emit('resultClickFj');
      });
    },
    handleCancelFjResult() {
      this.$nextTick(() => {
        this.$bus.$emit('resultClickFj');
      });
    },

    handleSaveRoadClick() {
      this.$bus.$emit('roadSaveClick');
    },

    cancelCreateFengji(value) {
      this.$store.commit('WindFarm/UPDATE_TUILIST');
      this.handleAddFengji(value);
      this.manualFengjiList = [];
    },
    toFixed,
    handleCloseModalClick() {
      this.$bus.$emit('farmClick', 1);
    },
    handleSaceFengjiClick() {
      const myItem = this.manualTypeList.find(
        item => item.label === this.manualTurbineParam.turbineType
      );

      if (!myItem) {
        return this.$message.warning(
          `机型${this.manualTurbineParam.turbineType}已经从机型库删除，请重新选择机型`
        );
      }

      this.manualTurbineParam.turbineTypeId = myItem.id;

      if (!this.manualFengjiList.length) {
        return this.$message.warning('请添加风机');
      }

      const lats = this.manualFengjiList.map(i => i.data.lat).join(',');
      const lons = this.manualFengjiList.map(i => i.data.lon).join(',');
      const turbineTypeId = this.manualFengjiList.map(
        () => this.manualTurbineParam.turbineTypeId
      );

      const turbineIds = this.manualFengjiList.map(() => '0').join(',');

      this.validateFengji(
        {
          lats,
          lons,
          turbineTypeId: turbineTypeId[0],
          turbineIds
        },
        () => {
          if (!lats && !lons) {
            return this.$message.warning('请在地图上手动添加风机');
          }

          this.$postForm('/windfarm/windfarm/manualTurbine', {
            data: {
              height: this.manualTurbineParam.turbineHeight,
              turbineTypeId: this.manualTurbineParam.turbineTypeId,
              windfarmId: this.$route.query.windfarmId,
              lats,
              lons
            },
            showSuccess: true,
            showError: true,
            showLoading: true
          }).then(() => {
            this.$store.dispatch('WindFarm/getWindfarmTurbineList', {
              params: {
                windfarmId: this.$route.query.windfarmId
              }
            });

            this.manualFengjiList = [];

            this.handleAddFengji(false);
          });
        }
      );
    },
    handleDeployClick() {
      const params = this.rowItemList.reduce((acc, cur) => {
        const key = cur.key;
        const value = cur.value;
        acc[key] = value;
        return acc;
      }, {});

      const turbineType = params['turbineType'];

      const turbineTypeId = this.turbineTypeList.find(
        item => item.label === turbineType
      )?.id;

      if (!turbineTypeId) {
        return this.$message.warning(
          `机型${turbineType}已经从机型库删除，请重新选择机型`
        );
      }

      delete params.turbineType;

      this.$postForm('/windfarm/windfarm/selectionStartDeployTurbine', {
        data: {
          ...params,
          turbineTypeId,
          windfarmId: this.$route.query.windfarmId
        },
        showError: true,
        showSuccess: true,
        showLoading: true
      }).then(() => {
        this.$store.dispatch('WindFarm/getWindfarmTurbineList', {
          params: {
            windfarmId: this.$route.query.windfarmId
          }
        });

        // 更新道路
        this.$store.dispatch('WindFarm/getRoadList', {
          params: {
            windfarmId: this.$route.query.windfarmId
          }
        });
      });
    },
    handleViewSyzClick(item, index) {
      const newArr = this.boosterList;
      const { isShow } = item;
      newArr[index].isShow = !isShow;
      this.$store.commit('WindFarm/SET_BOOSTERLIST', newArr);
      this.$store.commit('WindFarm/UPDATE_BOOST_AREA', newArr);
    },
    handleViewClick(item, index) {
      const newArr = this.exclusiveList;

      const { isShow } = item;
      newArr[index].isShow = !isShow;
      this.$store.commit('WindFarm/SET_EXCLUSIVELIST', newArr);
      this.$store.commit('WindFarm/UPDATE_LIMIT_AREA', newArr);
    },
    addExclusive(data) {
      const str = parseMapDataToGeoInfo(data, 'Polygon');

      this.$postForm('/windfarm/windfarm/saveWindfarmExclusive', {
        data: {
          geometryInfo: str,
          windfarmId: this.$route.query.windfarmId
        },
        showError: true,
        showSuccess: true
      })
        .then(() => {
          this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
          this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');

          this.$store.dispatch('WindFarm/getWindfarmExclusive', {
            params: {
              windfarmId: this.$route.query.windfarmId
            }
          });
        })
        .catch(() => {
          this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
        });
    },
    applyTur() {
      this.$postForm('/windfarm/windfarm/fullTurbineSet', {
        showError: true,
        showSuccess: true,
        params: {
          turbineTypeId: this.manualTurbineParam.turbineTypeId,
          windfarmId: this.$route.query.windfarmId
        }
      }).then(() => {
        // TODO 请求风机
      });
    },
    applyHeight() {
      this.$postForm('/windfarm/windfarm/fullHeightSet', {
        showError: true,
        showSuccess: true,
        params: {
          height: this.manualTurbineParam.turbineHeight,
          windfarmId: this.$route.query.windfarmId
        }
      }).then(() => {
        // TODO 请求风机
      });
    },
    queryManualParams() {
      this.$fetch('/windfarm/windfarm/getManualTurbineParam', {
        showError: true,
        params: {
          windfarmId: this.$route.query.windfarmId
        }
      }).then(res => {
        const { data } = res;
        const { turbineTypeList = [], manualTurbineParam = {} } = data;

        this.manualTypeList = turbineTypeList.map(i => {
          return {
            label: i.turbineType,
            value: i.turbineType,
            id: i.turbineTypeId
          };
        });
        this.manualTurbineParam = manualTurbineParam;
      });
    },
    queryAutoParams() {
      this.$fetch('/windfarm/windfarm/getAutoTurbineParam', {
        showError: true,
        params: {
          windfarmId: this.$route.query.windfarmId
        }
      }).then(res => {
        const { data } = res;
        const { turbineTypeList, autoTurbineParam } = data;

        this.turbineTypeList = turbineTypeList.map(i => {
          return {
            label: i.turbineType,
            value: i.turbineType,
            id: i.turbineTypeId
          };
        });

        this.autoTurbineParam = autoTurbineParam;

        this.rowItemList.forEach(item => {
          item.value = this.autoTurbineParam[item.key];
        });

        const selectTypeItem = this.rowItemList.find(
          i => i.label === '风机类型'
        );
        this.$set(selectTypeItem, 'selectOptions', this.turbineTypeList);
      });
    },
    addBooster(data) {
      const { lat, lng: lon } = data;

      this.$bus.$emit('getWindScopeData', map => {
        const poly = map.map(item => [item.lat, item.lng]);
        const result = booleanPointInPolygon([lat, lon], [poly]);

        if (!result) {
          this.$store.commit('WindFarm/POP_MAP_POINT');
          return this.$message.warning('升压站必须在风场内部');
        }
        this.$postForm('/windfarm/windfarm/saveBooster', {
          showError: true,
          showSuccess: true,
          data: {
            lat,
            lon,
            windfarmId: this.$route.query.windfarmId
          }
        })
          .then(() => {
            this.$store.commit('WindFarm/POP_MAP_POINT');
            this.handleShengyaAddClick(false);

            this.queryBoosterList();
          })
          .catch(() => {
            this.$store.commit('WindFarm/POP_MAP_POINT');
          });
      });
    },

    validateFengji(params, success = () => {}) {
      this.$postForm('/windfarm/windfarm/fanGroupCheck', {
        data: {
          ...params,
          windfarmId: this.$route.query.windfarmId
        },
        showLoading: true,
        noJudge: true
      }).then(re => {
        const res = re.data;

        const { code, message } = res;

        if (code == 0) {
          success();
        }

        if (code == 1) {
          return this.$message.error(message);
        }

        if (code == 2) {
          this.$confirm(message, '提醒', {
            confirmButtonText: '继续保存',
            cancelButtonText: '取消',
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            success();
          });
        }
      });
    },

    createfengji(data) {
      const { lat, lng: lon } = data;

      this.$bus.$emit('getWindScopeData', map => {
        const poly = map.map(item => [item.lat, item.lng]);
        const result = booleanPointInPolygon([lat, lon], [poly]);

        if (!result) {
          this.$store.commit('WindFarm/POP_MAP_POINT');

          return this.$message.warning('风机必须在风场内部');
        }

        this.manualFengjiList.push({
          data: {
            lat,
            lon
          }
        });
      });
    },
    queryBoosterList() {
      this.$store.dispatch('WindFarm/getBoosterList', {
        params: {
          windfarmId: this.$route.query.windfarmId
        }
      });
    },
    queryLimitList() {
      this.$fetch('/windfarm/windfarm/getWindfarmExclusive', {
        showError: true,
        params: {
          windfarmId: this.$route.query.windfarmId
        }
      }).then(res => {
        const { data = {} } = res || {};
        let { windfarmExclusiveList = [] } = data;

        if (!windfarmExclusiveList) {
          windfarmExclusiveList = [];
        }

        this.limitList = windfarmExclusiveList;
      });
    },
    handleTabClick(item) {
      this.tabList.forEach(i => {
        if (i !== item) {
          i.active = false;
        } else {
          i.active = true;
        }
      });
    },
    handleAddFengji(value) {
      // if (this.specificDragFlag && !!value) {
      //   return this.$message.warning('风机调整中，不可添加风机');
      // }

      if (value) {
        this.handleCancelFjResult();
      } else {
        this.$nextTick(() => {
          this.$bus.$emit('resultClickFj');
        });
      }

      let status;

      if (value !== undefined) {
        status = !value;
      } else {
        status = this.toolUIStatus['fengji'];
      }

      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
      this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
        key: 'fengji',
        value: !status
      });

      this.$bus.$emit('getMapInstance', map => {
        map.setDefaultIcon(
          L.icon({
            iconUrl: require('../images/fengji.png'),
            iconSize: [40, 40],
            iconAnchor: [20, 40]
          })
        );
      });

      this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
        key: 'drawMarker',
        value: !status
      });
    },
    handleLimitClick(value) {
      let status;

      if (value !== undefined) {
        status = !value;
      } else {
        status = this.toolUIStatus['limitAdd'];
      }

      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
      this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
        key: 'limitAdd',
        value: !status
      });

      this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
        key: 'drawPolygon',
        value: !status
      });
    },
    handleDelLimitClick(item, index) {
      this.$confirm(`是否删除该限制区域 ${Number(index) + 1}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.$postForm('/windfarm/windfarm/deleteWindfarmExclusive', {
          showError: true,
          showSuccess: true,
          data: {
            exclusiveId: item.exclusiveId
          }
        }).then(() => {
          this.$store.dispatch('WindFarm/getWindfarmExclusive', {
            params: {
              windfarmId: this.$route.query.windfarmId
            }
          });
        });
      });
    },
    handleDelBoostClick() {
      this.$confirm(`是否删除该升压站`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.$postForm('/windfarm/windfarm/deleteBooster', {
          showSuccess: true,
          showError: true,
          data: {
            windfarmId: this.$route.query.windfarmId
          }
        }).then(() => {
          this.queryBoosterList();
        });
      });
    },
    handleShengyaAddClick(value) {
      let status;

      if (value !== undefined) {
        status = !value;
      } else {
        status = this.toolUIStatus['shengyazhanAdd'];
      }

      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
      this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
        key: 'shengyazhanAdd',
        value: !status
      });

      this.$bus.$emit('getMapInstance', map => {
        map.setDefaultIcon(
          L.icon({
            iconUrl: require('../images/shengyazhan.png'),
            iconSize: [20, 20],
            iconAnchor: [10, 20]
          })
        );
      });

      this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
        key: 'drawMarker',
        value: !status
      });
    }
  }
};
</script>

<style lang="less" scoped>
.mr-10 {
  margin-right: 5px;
}
.width-40 {
  font-size: 12px;
  height: 100%;
  width: 60px;
}
.my-btn-warpper {
  display: flex;
  padding: 15px 10px;
  text-align: right;
  flex-direction: row-reverse;

  .ct-btn:last-child {
    margin-right: 10px;
  }
}
.upload-demo {
  height: 28px;
  .click-area {
    .file-name {
      width: 300px;
      height: 28px;
      border-radius: 7px;
      padding-left: 10px;
      text-align: left;
      margin-right: 20px;
      background-color: #fff;
      border: 2px solid #d9e6f3;
    }
    display: flex;
    justify-content: space-between;
  }
}
.my-content {
  padding: 10px 10px;
  .adjust-desc-new {
    margin-top: 10px;
    font-weight: bold;
    color: #e07a27;
  }
  .core {
    justify-content: space-between;
    // background-color: #fff;
    border-radius: 7px;
    display: flex;
    // padding: 10px;
    .tab {
      user-select: none;
      display: flex;
      align-items: center;
      .tab-item {
        height: 28px;
        width: 85px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        border: 2px solid #0877be;
        cursor: pointer;
        &:first-child {
          border-radius: 5px 0px 0px 5px;
        }
        &:last-child {
          border-radius: 0px 5px 5px 0px;
        }
        &.is-active {
          background-color: #0877be;
          color: #fff;
        }
      }
    }
  }
  .deploy-content {
    background-color: #fff;
    margin-top: 10px;
    border-radius: 7px;
    padding: 20px 20px 10px 20px;
  }
  .row {
    .row-item {
      display: inline-block;
      width: 150px;
      margin-bottom: 10px;
      &.place {
        width: 100%;
        &:nth-child(2n) {
          margin-left: 0px;
        }
        &:nth-child(2n + 1) {
          margin-left: 0px;
        }
        .row-item-core {
          display: flex;
          align-items: center;
          .key {
            margin-right: 5px;
            width: 60px;
            font-weight: 500;
          }
          .value {
            width: 280px;
          }
        }
      }
      &:nth-child(2n + 1) {
        margin-left: 30px;
      }
      .row-item-core {
        display: flex;
        align-items: center;
        .key {
          margin-right: 5px;
          min-width: 60px;
          font-weight: 500;
        }
        .value {
          min-width: 95px;
        }
      }
    }
  }

  .adjust-area {
    margin-top: 10px;
    text-align: right;
    .ct-btn {
      margin-left: 5px;
    }
  }

  .manual-row {
    margin-bottom: 10px;
    display: flex;
    align-content: center;
    .key {
      margin-right: 5px;
      width: 60px;
      line-height: 30px;
      font-weight: 500;
    }
    .value {
      width: 220px;
    }
    .el-btn-wrapper {
      margin-left: 10px;
    }
  }

  .deploy-btn-wrapper {
    margin-top: 10px;
    text-align: right;
    .ct-btn {
      &:first-child {
        margin-right: 10px;
      }
    }
  }
  .add-fengji-wrapper {
    text-align: right;
    margin-top: 10px;
  }

  .add-fengji {
    display: inline-block;
    i {
      cursor: pointer;
      &:hover {
        color: #478beb;
      }
      &.is-active {
        color: #0159ac;
      }
    }
    font-weight: normal;
    font-size: 16px;
    color: #000;
    position: relative;
    .ct-btn {
      margin-left: 5px;
    }
  }

  .adjust-desc {
    position: relative;
    left: -15px;
    font-size: 14px;
    font-weight: bold;
  }

  .limit-area,
  .shengyazhan-area {
    margin-top: 10px;
    .my-title {
      font-weight: normal;
      font-size: 16px;
      color: #000;
      padding: 0px 10px;
      position: relative;
      &::before {
        content: '';
        display: block;
        position: absolute;
        left: 0px;
        top: 1px;
        border-radius: 3px;
        width: 5px;
        height: 100%;
        background-color: #015aac;
      }
      i {
        cursor: pointer;
        &:hover {
          color: #478beb;
        }
        &.is-active {
          color: #0159ac;
        }
      }
    }
    .area-content {
      margin-top: 10px;
      padding: 0px 10px;
      max-height: 120px;
      overflow: auto;
    }
    .depoly-content-item {
      &:nth-child(n + 1) {
        margin-top: 5px;
      }
      display: flex;
      align-items: center;
      position: relative;
      & > span {
        display: flex;
        align-items: center;
      }

      .btns {
        display: flex;
        align-items: center;
        position: absolute;
        right: 0;
        i {
          display: flex;
          align-items: center;
          cursor: pointer;

          &.is-active {
            color: #3cc2e6;
          }
          &:hover {
            color: #478beb;
          }
          &:nth-child(n + 2) {
            margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>
